export const locales = {
  en: { name: 'En', code: 'en', intlLocale: 'en' },
  ru: { name: 'Рус', code: 'ru', intlLocale: 'ru' },
  cn: { name: '中文', code: 'cn', intlLocale: 'zh' },
  jp: { name: '日本語', code: 'jp', intlLocale: 'ja' },
}

export const regionLocales = {
  global: [
    locales.en,
    locales.ru,
    locales.cn,
    locales.jp,
  ],
  cn: [
    locales.cn,
    locales.en,
  ],
}



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/data/locales.js